import React from 'react'

import Icon from '../../Icon2/Icon'

const SingleRowSelectedUi = (props) => {
    return (
        <>
            {props.children}
            <Icon icon="SelectSingle" size="original" className="single-select" />
        </>
    )
}

export default SingleRowSelectedUi